"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteTherapyNoteSuccess = exports.updateTherapyNoteSuccess = exports.createTherapyNoteSuccess = void 0;
const effects_1 = require("redux-saga/effects");
const toast_1 = require("@/components/toast");
const constants_1 = __importStar(require("@/constants"));
const history_1 = __importDefault(require("@/helpers/history"));
function* createTherapyNoteSuccess(action) {
    var _a;
    const { payload } = action;
    yield effects_1.call(toast_1.showToast, '', constants_1.default.patientProgress.therapyNote.noteCreated);
    yield effects_1.call(history_1.default.push, constants_1.Routes.PatientProgressDetail.replace(':accountId', (_a = payload === null || payload === void 0 ? void 0 : payload.meta) === null || _a === void 0 ? void 0 : _a.accountId));
}
exports.createTherapyNoteSuccess = createTherapyNoteSuccess;
function* updateTherapyNoteSuccess() {
    yield effects_1.call(toast_1.showToast, '', constants_1.default.patientProgress.therapyNote.noteUpdated);
}
exports.updateTherapyNoteSuccess = updateTherapyNoteSuccess;
function* deleteTherapyNoteSuccess(action) {
    var _a;
    const { payload } = action;
    yield effects_1.call(toast_1.showToast, '', constants_1.default.patientProgress.therapyNote.noteSuccessfullyDeleted);
    yield effects_1.call(history_1.default.push, constants_1.Routes.PatientProgressDetail.replace(':accountId', (_a = payload === null || payload === void 0 ? void 0 : payload.meta) === null || _a === void 0 ? void 0 : _a.accountId));
}
exports.deleteTherapyNoteSuccess = deleteTherapyNoteSuccess;
